//  This file will be loaded on all pages, regardless of theme.

import "packs/public-path";

require.context("../images/", true);
